import React, { useEffect, useState } from 'react';
import ExternalLink from '../../../../../../shared/components/ExternalLink';
import { t, tBB } from '../../../../../../shared/components/l10n/l10n';

import ErrorOnboardingIllustration from '../../assets/Error-onboarding.png';
import ErrorUpdateBankAccountIllustration from '../../assets/Update-bankAccount.png';
import { SmartPayIntegrationError } from '../../types';

const SmartPayOnboardingErrorContent = ({ errorCode }: { errorCode: string }) => {
    const [icon, setIcon] = useState(ErrorOnboardingIllustration);
    const [message, setMessage] = useState(tBB(SmartPayIntegrationError.SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_DEFAULT_MESSAGE));

    useEffect(() => {
        let error = tBB(errorCode);
        const doesErrorMessageHaveTranslation = error !== errorCode;

        if (!doesErrorMessageHaveTranslation) return;

        //custom error states
        if (errorCode === SmartPayIntegrationError.SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_ACCOUNT_NUMBER_LENGTH_INVALID) {
            setIcon(ErrorUpdateBankAccountIllustration);
            setMessage(
                <>
                    <p>{error}</p>
                    <p>
                        {tBB(`SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_ACCOUNT_NUMBER_LENGTH_INVALID_CTA`, {
                            __LINK: content => (
                                <ExternalLink href="/settings/company/bank-accounts" target="_blank">
                                    {content}
                                </ExternalLink>
                            ),
                        })}
                    </p>
                </>
            );
        } else {
            setMessage(error);
        }
    }, [errorCode]);

    return (
        <>
            <img src={icon} alt="Error onboaring illustration" className="w-48 my-6 mx-auto" />
            <h2 className="my-4 text-center">{t`SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_TITLE`}</h2>
            <div className="flex flex-col items-center py-2">
                <span>{message}</span>
            </div>
        </>
    );
};

export default SmartPayOnboardingErrorContent;
